<mat-card class="kpi-profile-page-container">
    <div class="profile-main-area">
        <div class="profile-title-and-summary-area">
            <div *ngIf="scorecardListView && !selectDatesAndPositions && !viewKPIScorecardProfile">
                <div class="kpi-profile-heading">KPI Profiles</div>
            </div>
            <div *ngIf="selectDatesAndPositions && !scorecardListView && !viewKPIScorecardProfile">
                <div class="kpi-profile-heading">
                    Set Up KPI Profile - {{ selectedKPIScorecard.kpiScorecard }}
                </div>
            </div>
            <div *ngIf="viewKPIScorecardProfile && !scorecardListView && !selectDatesAndPositions">
                <div *ngIf="selectKPIs || setKPIWeights">
                    <div class="kpi-profile-heading">
                        Set Up KPI Profile - {{ selectedKPIScorecard.kpiScorecard }}
                    </div>
                </div>
                <div *ngIf="viewKPIs">
                    <div class="kpi-profile-heading">
                        Edit KPI Profile - {{ selectedKPIScorecard.kpiScorecard }}
                    </div>
                </div>
            </div>
        </div>

        <div class="profile-button-container">
            <div class="profile-button-area" *ngIf="!scorecardListView">
                <button
                    mat-stroked-button
                    *ngIf="viewKPIs && viewKPIScorecardProfile"
                    (click)="returnToKpiProfilesClicked()"
                >
                    Return to all KPI Profiles
                </button>
                <button
                    mat-stroked-button
                    (click)="editButtonCliecked()"
                    *ngIf="viewKPIs && viewKPIScorecardProfile"
                >
                    EDIT
                </button>

                <button
                    *ngIf="selectKPIs || setKPIWeights || selectDatesAndPositions"
                    mat-stroked-button
                    (click)="cancelClicked()"
                >
                    CANCEL
                </button>
                <button mat-stroked-button *ngIf="setKPIWeights" (click)="backToSelectKPIs()">
                    BACK
                </button>
                <button
                    mat-stroked-button
                    *ngIf="(!setKPIWeights && !viewKPIs) || selectDatesAndPositions"
                    (click)="onNext(selectedKPIScorecard)"
                >
                    NEXT
                </button>
                <button
                    *ngIf="selectKPIs || setKPIWeights || selectDatesAndPositions"
                    mat-stroked-button
                    class="margin-button"
                    [disabled]="totalWeightPercentage != 100"
                    (click)="onSubmit()"
                >
                    SUBMIT
                    <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="data-description-area">
        <div *ngIf="scorecardListView && !selectDatesAndPositions && !viewKPIScorecardProfile">
            <div class="kpi-profile-heading-subtext">
                KPI Profiles outline the KPIs, KPI weight if applicable, and the employee position
                type assigned to each Scorecard. Scorecard assignment is also used for Rankings.
            </div>
            <div class="kpi-summary-search-area">
                <search-dialog (searchOutput)="searchSummaryGrid($event)" [searchBoxHeight]="44">
                </search-dialog>
            </div>
        </div>
        <div *ngIf="viewKPIScorecardProfile && !scorecardListView && !selectDatesAndPositions">
            <div class="kpi-profile-sub-title-and-search-container">
                <div class="kpi-profile-sub-topic-area">
                    <div class="profile-subtopic">
                        Key Performance Indicators
                        <span *ngIf="setKPIWeights">Weights</span>
                    </div>
                    <div *ngIf="selectKPIs || setKPIWeights">
                        <div class="profile-description" *ngIf="selectKPIs">
                            Select the key performance indicators (KPI) to be used for scorecard.
                        </div>
                        <div *ngIf="setKPIWeights">
                            <div class="profile-description">
                                Set the <b>Weight</b> for each KPI to be used in the weighted score
                                calculation. The sum of all weights must equal 100%. To exclude a
                                KPI from weighted scores, leave Weight blank or set to 0.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kpi-profile-search-area">
                    <search-dialog
                        (searchOutput)="searchRows($event)"
                        [searchId]="'kpi-profile-view'"
                        [searchBoxHeight]="44"
                        [resetSearch]="searchTerm === '' || searchTerm === null"
                    >
                    </search-dialog>
                </div>
            </div>
            <div class="position-area" *ngIf="selectedKPIScorecard?.positions?.length > 0">
                <div class="position-text">Position(s)</div>
                <div class="view-positions">
                    <ng-container *ngFor="let position of selectedKPIScorecard.positions">
                        <div>{{ position }}</div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="scorecardListView && !selectDatesAndPositions && !viewKPIScorecardProfile">
        <!--<common-kendo-table
            [tableColumnProperties]="summaryTableColumnProperties"
            [tableDataProperties]="summaryTableDataProperties"
        >
        </common-kendo-table>-->
        <kendo-grid
            #grid="kendoGrid"
            [data]="gridView"
            [sortable]="sortable"
            [scrollable]="'scrollable'"
            [height]="700"
            [loading]="loading"
            [sort]="sort"
            (sortChange)="sortChange($event)"
        >
            <!---->
            <ng-template kendoGridNoRecordsTemplate>
                <div style="opacity: 0.8" *ngIf="!loading">Scorecard Not Found</div>
            </ng-template>
            <kendo-grid-column
                field="kpiScorecard"
                title="SCORECARD"
                [headerStyle]="getHeaderStyle()"
                [width]="200"
                [sortable]="true"
            >
                <ng-template kendoGridCellTemplate let-record let-rowIndex="rowIndex">
                    <ng-template
                        *ngIf="record?.isAssigned; then Assigned; else NotAssigned"
                    ></ng-template>
                    <ng-template #Assigned>
                        <span (click)="viewScorecardClicked(record)" class="hyperlink-style">
                            {{ record?.kpiScorecard }}
                        </span>
                    </ng-template>
                    <ng-template #NotAssigned>
                        {{ record?.kpiScorecard }}
                    </ng-template>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
                field="positions"
                title="POSITIONS"
                [headerStyle]="getHeaderStyle()"
                [width]="200"
                [sortable]="true"
            >
                <ng-template kendoGridCellTemplate let-record let-rowIndex="rowIndex">
                    <ng-template
                        *ngIf="record?.positions?.length > 0; then Assigned; else NotAssigned"
                    ></ng-template>
                    <ng-template #Assigned>
                        {{ record?.positions?.join(' | ') }}
                    </ng-template>
                    <ng-template #NotAssigned>
                        <span
                            *ngIf="record?.kpiScorecardType === 'Employee'"
                            (click)="editScorecardClicked(rowIndex)"
                            class="hyperlink-style"
                        >
                            Assign Now
                        </span>
                    </ng-template>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
                field="numKPIs"
                title="# KPIS"
                [headerStyle]="getHeaderStyle()"
                [width]="100"
                [sortable]="true"
            >
            </kendo-grid-column>

            <kendo-grid-column
                field="numEmployees"
                title="# ASSIGNED"
                [headerStyle]="getHeaderStyle()"
                [width]="150"
                [sortable]="true"
            >
            </kendo-grid-column>

            <kendo-grid-column
                field="effectiveDate"
                title="EFFECTIVE"
                [headerStyle]="getHeaderStyle()"
                [width]="150"
                [sortable]="true"
            >
                <ng-template kendoGridCellTemplate let-record>
                    {{ record.effectiveDate | date : 'MM/dd/yyyy' : 'UTC' }}
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
                field="inActiveDate"
                title="INACTIVE"
                [headerStyle]="getHeaderStyle()"
                [width]="150"
                [sortable]="true"
            >
                <ng-template kendoGridCellTemplate let-record>
                    {{ record.inActiveDate | date : 'MM/dd/yyyy' : 'UTC' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
                field="edit"
                title=""
                [headerStyle]="getHeaderStyle()"
                [width]="90"
                [sortable]="false"
            >
                <ng-template kendoGridCellTemplate let-record let-rowIndex="rowIndex">
                    <i
                        (click)="editScorecardClicked(rowIndex)"
                        class="far fa-pencil-alt"
                        style="cursor: pointer"
                    ></i>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
    <div
        *ngIf="selectDatesAndPositions && !scorecardListView && !viewKPIScorecardProfile"
        class="position-setup-area"
    >
        <form [formGroup]="scorecardForm">
            <div class="date-picker-div">
                <div class="date-label">Effective Date</div>
                <kendo-datepicker
                    class="date-picker"
                    format="MM/dd/yyyy"
                    formControlName="effectiveDate"
                >
                </kendo-datepicker>
            </div>
            <div class="date-picker-div">
                <div class="date-label">Inactive Date</div>
                <kendo-datepicker
                    class="date-picker"
                    format="MM/dd/yyyy"
                    formControlName="inactiveDate"
                >
                </kendo-datepicker>
            </div>
            <div class="position-title-area">
                <div>Position(s)</div>
                <div class="position-description">
                    Select the position(s) to be assigned the KPI profile.
                </div>
            </div>
            <div class="position-table-area">
                <table>
                    <ng-container *ngFor="let position of staffPositions; let i = index">
                        <tr>
                            <td style="width: 40px">
                                <p-checkbox
                                    [binary]="true"
                                    [disabled]="
                                        position.checked &&
                                        !selectedPositionKeys.has(position.staffPositionKey)
                                    "
                                    (onChange)="
                                        positionCheckboxChangeHandler(
                                            $event.checked,
                                            position.staffPositionKey
                                        )
                                    "
                                />
                            </td>
                            <td>
                                {{ position.position }}
                            </td>
                        </tr>
                    </ng-container>
                </table>
            </div>
        </form>
    </div>
    <div *ngIf="viewKPIScorecardProfile && !scorecardListView && !selectDatesAndPositions">
        <div [ngClass]="{ 'app-kpi-scorecard': profileTableDataProperties.gridData.length > 12 }">
            <div class="total-weight-error-message">
                <!--<div class="total-weight-percentage-value">
                    Total weight percentage = <span>{{ totalWeightPercentage }}%</span>
                </div>-->
                <div *ngIf="totalWeightPercentage != 100 && setKPIWeights">
                    The total percentage must be 100%
                </div>
            </div>
            <custom-mat-table
                [customTableInfo]="customTableInfo"
                (contentChanged)="profileContentChangeEvent($event)"
                (inputChangeEvent)="profileInputChangeEvent($event)"
                [footerObject]="footerObject"
            ></custom-mat-table>
        </div>
    </div>
</mat-card>
